export default {
  id: 54,
  title: 'Target #54 - Black Lives Matter',
  url: 'https://cssbattle.dev/play/54',
  colors: ['#191919', '#F9E492'],
  solution:
    '<a a><a b><a c><a d><a e><a f><a g><style>body{background:#F9E492}a{position:fixed;background:#191919}a[a],a[b],a[c],a[d],a[g]{width:20;border-radius:25px;bottom:167}a[a],a[c]{height:45}a[a]{left:155}a[b]{left:180;height:55}a[c]{left:205}a[d]{left:230;height:35}a[e],a[f]{border-radius:0 0 10px 10px}a[e]{top:138;left:150;width:100;height:40}a[f]{top:178;left:175;width:50;height:45}a[g]{bottom:121;left:152;height:65;transform:rotate(60deg);border:5px solid #F9E492}</style>',
}
